import styled from 'styled-components';

export const BlockEventSingleTitle = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.65);
  height: 28px;
`;
